import classNames from 'classnames'
import * as React from 'react'

import styles from './ProgressBar.css'

type OwnProps = {
  percent: number
  size: number
  activeCircleClassName?: string
  inactiveCircleClassName?: string
  stopAnimation?: boolean
}

const DEFAULT_SIZE = 16
const HUNDRED_PERCENT = 100
const GAP_TO_BORDER = 2

function ProgressBar({
  percent,
  size = DEFAULT_SIZE,
  stopAnimation = false,
  activeCircleClassName,
  inactiveCircleClassName,
}: OwnProps) {
  let percentToRender = percent

  if (percent < 0 || !percent) {
    percentToRender = 0
  }

  if (percent > HUNDRED_PERCENT) {
    percentToRender = HUNDRED_PERCENT
  }

  const iconDiameter = size - GAP_TO_BORDER * 2
  const iconRadius = iconDiameter / 2
  const iconGap = (size - iconDiameter) / 2
  const circumference = iconRadius * Math.PI * 2
  const length = (circumference / HUNDRED_PERCENT) * percentToRender
  const xStart = size / 2
  return (
    <svg height={size} width={size} viewBox={`0 0 ${size} ${size}`}>
      <path
        className={classNames(styles.inactiveCircle, inactiveCircleClassName)}
        d={`M${xStart} 1
        a ${size / 2 - 1} ${size / 2 - 1} 0 0 1 0 ${size - 2}
        a ${size / 2 - 1} ${size / 2 - 1} 0 0 1 0 ${-(size - 2)}`}
      />
      <path
        className={classNames(
          styles.activeCircle,
          stopAnimation === true && styles.stopAnimation,
          activeCircleClassName,
        )}
        strokeDasharray={`${length} ${circumference - length}`}
        d={`M${xStart} ${iconGap}
        a ${iconRadius} ${iconRadius} 0 0 1 0 ${iconDiameter}
        a ${iconRadius} ${iconRadius} 0 0 1 0 ${-iconDiameter}`}
      />
    </svg>
  )
}
export default React.memo(ProgressBar)
